export default __webpack_public_path__ + "resources/icons/d140-5459.webp";